
import React, { useState } from "react";
import Header from "../Components/Header";
import HelpMessage from "../Components/HelpMessage";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Login = () => {
  const [user, setUser] = useState("");
  
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); // New error state
  const navigate = useNavigate();

  // Check if current URL has ?user and token parameters
  const urlParams = new URLSearchParams(window.location.search);
  const paramUser = urlParams.get('user');
  const token = urlParams.get('deviceToken');

  if (paramUser && token) {
    // Verify token
    axios.get(`${process.env.REACT_APP_API_BASEURL}/login/verify`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
    .then(response => {
      if (response.status === 200) {
        const { role } = response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("currentUser", response.data.id);
        localStorage.setItem("role", role);
        // Set the default Axios authorization header to include the token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        // Remove user and token parameters from the URL
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('user');
        newUrl.searchParams.delete('deviceToken');
        newUrl.searchParams.delete('password');
        window.history.replaceState({}, document.title, newUrl.href);

        navigate("/Home");

      } else {
        console.error('Token verification failed');
      }
    })
    .catch(error => {
      console.error('Error verifying token:', error);
    });
  }

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASEURL}/login`, {
        user,
        password,
      });

      if (response.status === 200) {
        const { token, role } = response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("currentUser", response.data.id);
        localStorage.setItem("role", role);
        // Set the default Axios authorization header to include the token
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        navigate("/Home");
      } else {
        setError("Invalid username or password"); // Set the error message
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        setError(error.response.data.message || "Error during login. Please try again.");
      } else {
        setError("Error during login. Please try again.");
      }
    }
  };

  return (
    
    <div className="limiter">
      <div className="container-login100">
        <div className="wrap-login100">
          <Header />
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <div className="bg-transparent" id="form-wrapper">
            <div className="white-bg parent-logo shadow">
              <span className="login100-form-avatar">
                <img src={require("../Assets/Images/uds.jpg")} alt="udslogo" />
                {/* <label className="lblLogoTitle">Bondens App</label> */}
              </span>
            </div>

            <div className="wrap-input100 validate-input remove-old">
              <label
                className="pd-25"
                style={{
                  width: "130px",
                }}
              >
                User name
              </label>

              <input
                className="input100 inputBg shadow"
                value={user}
                onChange={(e) => setUser(e.target.value)
                }
                
                id="UserName"
                type="text"
              />

              <span className="focus-input100" />
            </div>

            <span className="text-danger" />

            <div className="wrap-input1002 validate-input m-b-50 remove-old">
              <label
                className="pd-25"
                style={{
                  width: "130px",
                }}
              >
                Password
              </label>

              <input
                className="input100 inputBg shadow"
                id="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <span className="focus-input100" data-placeholder="Password" />
            </div>

            <span className="text-danger" />

            <div className="container-login100-form-btn LoginButtonDiv">
              <button
                className="login100-form-btn"
                type="submit"
                value="Login"
                onClick={handleLogin}
              >
                <i className="icon fas fa-user" /> <span>Sign in</span>
              </button>

              <button
                className="login100-form-btn btnCancel"
                id="btnCancel"
                type="button"
                value="Cancel"
              >
                <i className="icon fas fa-times" /> <span>CANCEL</span>
              </button>
            </div>
            <div className="space-top container-fluid">
              <div className="row">
                <div className="col-xs-6">
                  <div className="container-login100-form-btn remember checkbox-remember">
                    <div className="checkbox">
                      <label>
                        <input
                          defaultValue="true"
                          id="Login_RememberMe"
                          name="RememberMe"
                          type="checkbox"
                        />
                        <span
                          className="cr"
                          style={{
                            background: "#000000",
                          }}
                        >
                          <i className="cr-icon fas fa-check" />
                        </span>
                        Remember me
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-xs-6">
                  <div className="pss-reset" id="loginfootertext">
                    <span className="reset">
                      <a
                        onClick={() => {
                          navigate("/ForgotPassword");
                        }}
                        style={{
                          color: "#000000",
                        }}
                      >
                        Reset Password
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <HelpMessage />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
